import React from 'react';

const LanguageHome = (props) => {

    return (
        <div>HOME</div>
    );
};
export default LanguageHome;